import { arrayOf, bool, oneOf, shape } from "prop-types";
import { useEffect, useMemo } from "react";

import ErrorBoundary from "web/Layout/ErrorBoundary";

import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";

import { createGtmImpressionProps, modifyImage } from "../utils/gtmPromoEvent";
import Desktop from "./Desktop";
import Mobile from "./Mobile";

const PageGeneratorSliderContainer = ({
  isMobile,
  params,
  availableCategories,
  promoItem,
}) => {
  const slides = useMemo(() => {
    return Object.keys(params).map((key) => {
      return typeof params[key] !== "string" && params[key];
    });
  }, [JSON.stringify(params)]);

  const slidesToRender = useMemo(() => {
    return slides.filter((slide) => {
      if (slide.image_category_ids) {
        if (slide.image_category_ids.includes(",")) {
          const slideCategoryIdsArray = slide.image_category_ids.split(",");
          const areAllCategoriesAvailable = slideCategoryIdsArray.every(
            (slideIdCat) => {
              return (
                availableCategories &&
                availableCategories.find((availableCat) => {
                  return availableCat.id === slideIdCat;
                })
              );
            }
          );
          return areAllCategoriesAvailable ? slide : null;
        }
        return isArrayHasItems(availableCategories)
          ? availableCategories.find((category) => {
              return (
                slide.image_category_ids === category.id &&
                category.product_count > 0
              );
            })
          : null;
      }
      return slide;
    });
  }, [slides]);

  useEffect(() => {
    if (!slidesToRender || !slidesToRender?.length) return;

    const gtmOptions = slidesToRender.map(({ graphic_file }, index) => {
      const name = modifyImage(graphic_file);
      return {
        name,
        position: index + promoItem?.promoPosition,
        promotion_name: name,
        creative_slot: index + promoItem?.promoPosition,
      };
    });

    if (gtmOptions) {
      createGtmImpressionProps(gtmOptions);
    }
  }, [slidesToRender]);

  return slides ? (
    <ErrorBoundary>
      {isMobile ? (
        <Mobile
          slides={slidesToRender}
          promoPosition={promoItem?.promoPosition}
        />
      ) : (
        <Desktop
          slides={slidesToRender}
          promoPosition={promoItem?.promoPosition}
        />
      )}
    </ErrorBoundary>
  ) : null;
};

PageGeneratorSliderContainer.propTypes = {
  isMobile: bool,
  params: shape({}),
  availableCategories: arrayOf(shape({})),
  promoItem: oneOf([shape({}), null]),
};

PageGeneratorSliderContainer.defaultProps = {
  isMobile: false,
  availableCategories: [],
  params: {},
  promoItem: null,
};

export default PageGeneratorSliderContainer;
